import React from 'react';
export function Footer() {
  return <footer className="bg-[#075985] text-white py-12 px-4 text-center" data-id="element-143">
      <div className="max-w-4xl mx-auto" data-id="element-144">
        <div className="text-2xl font-bold text-white/90 mb-6 uppercase tracking-widest" data-id="element-145">
          🏑 HOCKEY 360™
        </div>

        <div className="flex flex-col md:flex-row justify-center items-center gap-4 md:gap-8 text-white/70 mb-8 text-sm md:text-base" data-id="element-146">
          <a href="mailto:contacto@hockey360.com.ar" className="hover:text-white transition-colors" data-id="element-147">
            📧 contacto@hockey360.com.ar
          </a>
          <span className="hidden md:inline text-white/20" data-id="element-148">|</span>
          <a href="#" className="hover:text-white transition-colors" data-id="element-149">
            📲 @hockey360.ar
          </a>
          <span className="hidden md:inline text-white/20" data-id="element-150">|</span>
          <a href="#" className="hover:text-white transition-colors" data-id="element-151">
            🌐 www.hockey360.ar
          </a>
        </div>

        <p className="text-white/40 text-xs" data-id="element-152">
          © HOCKEY 360™ 2026 — Todos los derechos reservados. Prohibida la
          reproducción y redistribución sin autorización expresa.
        </p>
      </div>
    </footer>;
}